import { getSocialProofV2Template, getVueSocialProofV2Template } from "../../shortcodes/templates";

let socialProofV2 = null;

const visualizeSocialProofV2 = content => {
  socialProofV2 = content.querySelectorAll('[data-wrapper-id="social-proof-v2"]');
  if (socialProofV2.length > 0) {
    socialProofV2.forEach(item => {
      item.innerHTML = getSocialProofV2Template();
    });
  }
};

const serializeSocialProofV2 = content => {
  socialProofV2 = content.querySelectorAll('[data-wrapper-id="social-proof-v2"]');
  if (socialProofV2.length > 0) {
    socialProofV2.forEach(item => {
      const proofData = item.getAttribute("data-social-proof-v2-data");
      item.innerHTML = getVueSocialProofV2Template(proofData);
    });
  }
};

export { visualizeSocialProofV2, serializeSocialProofV2 };
